const clearFunctions: (() => void)[] = [];

export const registerClearFunction = (clearFunction: () => void): void => {
  clearFunctions.push(clearFunction);
};

export const clearReactiveVars = (): void => {
  clearFunctions.forEach((clearFunction) => {
    clearFunction();
  });
};
